import {A11yModule} from '@angular/cdk/a11y';
import {AssignedProjectsComponent} from './components/assigned-projects/assigned-projects.component';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {ColorPickerDirective} from 'ngx-color-picker';
import {CommonModule} from '@angular/common';
import {CountrySelectComponent} from './components/country-select/country-select.component';
import {DeleteConfirmDialogModule} from './delete-confirm-dialog/delete-confirm-dialog.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {DurationComponent} from './components/duration/duration.component';
import {EditModalLayoutModule} from './edit-modal-layout/edit-modal-layout.module';
import {EditableModule} from './editable/editable.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FocusableDirective} from './focusable.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LabelTextWrappingDirective} from './label-text-wrapping/label-text-wrapping.directive';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MAT_DATE_FORMATS, MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {OnlyNumbersDirective} from './only-numbers.directive';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {PortalModule} from '@angular/cdk/portal';
import {ProjectSelectComponent} from './components/project-select/project-select.component';
import {ResetPasswordDialogueComponent} from './reset-password-dialogue/reset-password-dialogue.component';
import {RetailerSelectComponent} from './components/retailer-select/retailer-select.component';
import {RouterModule} from '@angular/router';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {SelectInputComponent} from './components/select-input/select-input.component';
import {StartStoreVisitDialogComponent} from './components/start-store-visit-dialog/start-store-visit-dialog.component';
import {StateSelectComponent} from './components/state-select/state-select.component';
import {StatusComponent} from './components/status/status.component';
import {StatusInputComponent} from './components/status-input/status-input.component';
import {StoreAutocompleteComponent} from './components/store-autocomplete/store-autocomplete.component';
import {TranslateModule} from '@ngx-translate/core';
import {UserAutocompleteComponent} from './components/user-autocomplete/user-autocomplete.component';
import {UserEditGuardService} from '../users/user-edit-guard.service';
import {ValidInputComponent} from './components/valid-input/valid-input.component';
import {AppInjector} from './app-injector';
import {MultiLangInputComponent} from './components/multi-lang-input/multi-lang-input.component';
import {GenericAutocompleteComponent} from './components/generic-autocomplete/generic-autocomplete.component';
import {
  UserAutocompleteChipListComponent
} from './components/user-autocomplete-chip-list/user-autocomplete-chip-list.component';
import {SelectFormDialogComponent} from './components/select-form-dialog/select-form-dialog.component';
import {LanguageSelectComponent} from './components/language-select/language-select.component';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {DateRangeFilterComponent} from './components/date-range-filter/date-range-filter.component';
import {FormDateRangeFilterComponent} from './components/form-date-range-filter/form-date-range-filter.component';
import {
  AssignedPhotoCategoriesComponent
} from './components/assigned-photo-categories/assigned-photo-categories.component';
import {ColorPickerComponent} from './components/color-picker/color-picker.component';
import {NgxMatDatepickerInput, NgxMatDatetimepicker, NgxMatTimepickerComponent,} from '@ngxmc/datetime-picker';
import {CopyToClipboardComponent} from "./components/copy-to-clipboard/copy-to-clipboard.component";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {AssignedQueuesComponent} from './components/assigned-queues/assigned-queues.component';
import {
  AddressSuggestionIndicatorComponent
} from "./components/address-suggestion/address-suggestion-indicator.component";
import {MultiSelectInputComponent} from "./components/multi-select-input/multi-select-input.component";
import {InfoDialogComponent} from "./components/info-dialog/info-dialog.component";
import {InfoButtonComponent} from "./components/info-button/info-button.component";
import {SafePipe} from './pipes/safe.pipe';
import {NativeTimePickerDirective} from './native-time-picker.directive';


const MOMENT_DATETIME_WITH_SECONDS_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const INTL_DATE_INPUT_FORMAT = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hourCycle: 'h23',
  hour: '2-digit',
  minute: '2-digit',
};

const CUSTOM_MOMENT_FORMATS = {
  parse: {
    dateInput: MOMENT_DATETIME_WITH_SECONDS_FORMAT,
  },
  display: {
    dateInput: INTL_DATE_INPUT_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@NgModule({
  declarations: [
    AssignedProjectsComponent,
    CountrySelectComponent,
    DurationComponent,
    FocusableDirective,
    LabelTextWrappingDirective,
    OnlyNumbersDirective,
    PageNotFoundComponent,
    ProjectSelectComponent,
    ResetPasswordDialogueComponent,
    RetailerSelectComponent,
    SelectInputComponent,
    MultiSelectInputComponent,
    StartStoreVisitDialogComponent,
    StateSelectComponent,
    StatusComponent,
    StatusInputComponent,
    StoreAutocompleteComponent,
    UserAutocompleteComponent,
    GenericAutocompleteComponent,
    UserAutocompleteChipListComponent,
    ValidInputComponent,
    MultiLangInputComponent,
    SelectFormDialogComponent,
    LanguageSelectComponent,
    DateRangeFilterComponent,
    FormDateRangeFilterComponent,
    AssignedPhotoCategoriesComponent,
    ColorPickerComponent,
    CopyToClipboardComponent,
    AssignedQueuesComponent,
    AddressSuggestionIndicatorComponent,
    InfoDialogComponent,
    InfoButtonComponent,
    SafePipe,
    NativeTimePickerDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}), // hide the warning for ngModel in reactiveForm
    RouterModule,
    FlexLayoutModule,
    CdkTableModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    DragDropModule,
    TranslateModule,
    DeleteConfirmDialogModule,
    EditableModule,
    ColorPickerDirective,
    EditModalLayoutModule,
    PortalModule,
    NgxMatTimepickerComponent,
    NgxMatDatetimepicker,
    NgxMatDatepickerInput,
    ClipboardModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    FocusableDirective,
    DeleteConfirmDialogModule,
    EditableModule,
    ColorPickerDirective,
    ValidInputComponent,
    StoreAutocompleteComponent,
    AssignedProjectsComponent,
    StatusComponent,
    UserAutocompleteComponent,
    GenericAutocompleteComponent,
    UserAutocompleteChipListComponent,
    StartStoreVisitDialogComponent,
    DurationComponent,
    SelectInputComponent,
    StatusInputComponent,
    RetailerSelectComponent,
    CountrySelectComponent,
    StateSelectComponent,
    ProjectSelectComponent,
    LabelTextWrappingDirective,
    MultiLangInputComponent,
    LanguageSelectComponent,
    DateRangeFilterComponent,
    FormDateRangeFilterComponent,
    AssignedPhotoCategoriesComponent,
    ColorPickerComponent,
    NgxMatTimepickerComponent,
    NgxMatDatetimepicker,
    NgxMatDatepickerInput,
    CopyToClipboardComponent,
    AssignedQueuesComponent,
    AddressSuggestionIndicatorComponent,
    MultiSelectInputComponent,
    InfoButtonComponent,
    SafePipe,
    NativeTimePickerDirective,
  ],
  providers: [
    UserEditGuardService,
    MatDatepickerModule,
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
    {provide: MAT_DATE_FORMATS, useValue: CUSTOM_MOMENT_FORMATS},
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  constructor(injector:Injector){
    AppInjector.setInjector(injector);// save a injector ref
  }
}
